import {
  DetailsAvatar,
  DetailsSection,
  DetailsSubtitleText,
  DetailsText,
  DetailsTitleText,
  QuoteContainer,
  QuoteDown,
  QuoteHolder,
  // QuoteDownHolder,
  QuotesUp,
  SubtitleText,
} from "./Quote.styles";

interface Props {
  avatar: string;
  quoteBg: string;
  review: string;
}

const Quote = ({ avatar, quoteBg, review }: Props) => {
  return (
    <QuoteContainer>
      <QuoteHolder QuotePath={quoteBg}>
        <QuotesUp src="/assets/svg/quote-up.png" />
        <SubtitleText>{review}</SubtitleText>
        <QuoteDown src="/assets/svg/quote-down.png" />
      </QuoteHolder>

      <DetailsSection>
        <DetailsAvatar src={avatar} />
        <DetailsText>
          <DetailsTitleText>Jenny L.</DetailsTitleText>
          <DetailsSubtitleText>Co-Founder</DetailsSubtitleText>
        </DetailsText>
      </DetailsSection>
    </QuoteContainer>
  );
};

export default Quote;
